import debounce from 'lodash.debounce'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
// import Select from 'react-select'
import {
  FormDashboardTextarea as Textarea,
  FormDashboardLabel as Label,
  FormRow,
  AlertError,
  Button,
  FormDashboardInput
} from '../../../components'
import { updateOrganizationDirect } from '../../../features/organizations/slice'
import { /* inputNormalizer,  */useViewport } from '../../../utils'
import { resetMilestone, updateMilestone } from '../../../features/organization-form/slice'
import adapter from '../../../features/organization-form/adapter'
import service from '../../../features/organizations/service'
import DevLogger from '../../../components/_dev-logger'
import { fetchOrganization } from '../../../features/organization/slice'
import { toast } from 'react-toastify'

// function generateYears(){
//   let result = []
//   for (let index = 1990; index < new Date().getFullYear()+1; index++) {
//     result.push({
//       label: index.toString(),
//       value: index
//     })
//   }
//   return result
// }

// const yearOptions = generateYears()

const Form = ({ isEdit }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { isMobile } = useViewport()
  const [requesting, setRequesting] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState(null)
  const milestoneForm = useSelector(state => state.organizationForm.milestone)
  const [defaultValue, setDefaultValue] = React.useState({ year: new Date().getFullYear() })
  const myId = useSelector(state => state.account.profile.id)

  React.useEffect(() => {
    if(milestoneForm && isEdit){
      setDefaultValue(milestoneForm)
    } else {
      dispatch(resetMilestone())
    }
    // eslint-disable-next-line
  }, [/* milestoneForm, dispatch,  */isEdit])

  const handleInput = debounce((e) => {
    if(e.target && e.target !== null){
      const key = e.target.name
      const value = e.target.value
      dispatch(updateMilestone({key, value}))
    }
  }, 100)

  const isValid = (form) => {
    let result = true
    if(!form.year || (form.year && typeof form.year === 'object')){
      result = false
      toast.error('Invalid year.')
    }

    return result
  }

  const handleSubmit = (e) => {
    if(e.preventDefault){
      e.preventDefault()
    }

    if(isValid(milestoneForm)){
      setRequesting(true)
      setErrorMessage(null)

      console.log({milestoneForm})

      const cloned = {
        ...milestoneForm,
        year: milestoneForm.year.toString()
      }

      const data = {
        milestones: [ cloned ]
      }

      if(isEdit){
        service.updateMilestone({id: milestoneForm.id, data: cloned})
          .then(res => {
            console.log(res)
            toast.success('Milestone sucessfully updated!')
            dispatch(fetchOrganization(myId))
            history.push('/dashboard/organization/profile/milestones')
          })
          .catch(err => {
            console.log(err)
            toast.error('Error.')
            setErrorMessage(err)
          })
          .then(() => setRequesting(false))
      } else {
        // Send to backend
        dispatch(updateOrganizationDirect({
          id: myId,
          data: adapter.formToRequestBody(data, 'milestones'),
        }))
          .then(res => {
            toast.success('Milestone successfully created!')
            dispatch(fetchOrganization(myId))
            history.push('/dashboard/organization/profile/milestones')
          })
          .catch(err => {
            toast.error(err)
            setErrorMessage(err)
          })
          .then(() => setRequesting(false))
      }
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <p className="mt-8 xl:mt-0 text-lg mb-5 font-bold font-primary xl:hidden">
        Milestone
      </p>

      <DevLogger data={milestoneForm} />

      <FormRow>
        <Label>Year</Label>
        <FormDashboardInput
          type="number"
          className="text-sm lg:w-1/2"
          defaultValue={defaultValue.year}
          name="year"
          min="1900"
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
        {/* <Select
          className="text-sm lg:w-1/2"
          options={yearOptions}
          value={defaultYear}
          placeholder="Select Year"
          onChange={({value}) => inputNormalizer(value, 'year', handleInput)}
        /> */}
      </FormRow>
      <FormRow>
        <Label>Description (English)</Label>
        <Textarea
          className="w-full"
          rows={5}
          defaultValue={defaultValue.description_en}
          name="description_en"
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>
      <FormRow last>
        <Label>Description (Indonesia)</Label>
        <Textarea
          className="w-full"
          rows={5}
          defaultValue={defaultValue.description_id}
          name="description_id"
          onChange={(e) => {e.persist(); handleInput(e)}}
        />
      </FormRow>

      <div className="flex flex-wrap items-center mb-5 lg:mb-8">
        <div className="w-full md:w-auto lg:w-auto">
          <Button
            style={!isMobile ? {width: '197px'} : {}}
            thin={isMobile}
            disabled={requesting}
            isLoading={requesting}
          >
            <span>Save</span>
          </Button>
        </div>
        <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
          <Link to={`/dashboard/organization/profile/milestones`} className="px-8 text-gray-444 underline text-xs lg:text-sm">Cancel</Link>
        </div>
      </div>

      {
        errorMessage &&
        <AlertError
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      }
    </form>
  )
}

export { Form }
